import './newrelicConfig';

import React from 'react';

import { createRoot } from 'react-dom/client';

import './persikConfig';
import './pdfjsConfig';
import './talkdeskConfig';
import './fonts';

import './rootStyles.css';

import { App } from './App';
import { RootProvider } from './providers/RootProvider';

const rootElement = document.getElementById('app-root');

if (rootElement) {
  const reactRoot = createRoot(rootElement);

  reactRoot.render(
    <React.StrictMode>
      <RootProvider>
        <App />
      </RootProvider>
    </React.StrictMode>,
  );
}
